import { ISearchResult } from 'src/app/core/models/api/sane-project/arpa-model';
import { SearchResultViewModel } from '../models';

export abstract class SearchMapper {
  public static fromDtoToSResultVM(source: ISearchResult): SearchResultViewModel {
    return {
      projectId: source.projectId,
      projectDate: source.projectDate,
      projectName: source.projectName,
      totalBonus: source.totalBonus,
      clientDescription: source.clientName + ' [' + source.clientId + ']',
      clientProfession: source.clientProfession,
      clientAge: source.clientAge,
      userDescription: source.userName + ' [' + source.userId + ']',
      officeDescription: source.officeName + ' [' + source.officeAlias + ']'
    } as SearchResultViewModel;
  }
}
